{
  "OnavailablestateLabel": "Sur l'État disponible plus :",
  "OnbusystateLabel": "On Busy State Over :",
  "OnnaordndstateLabel": "On N\/A ou DND State Over :",
  "OnwrapupLabel": "Sur Wrap-Up State Over :",
  "OnavailablestateEnabledHiddenlabel": "Le paramètre On Available State Over est-il activé ?",
  "OnbusystateEnabledHiddenlabel": "Le paramètre de dépassement de l'état d'occupation est-il activé ?",
  "OnnaordndstateEnabledHiddenlabel": "Le paramètre On N\/A ou DND State Over est-il activé ?",
  "OnwrapupEnabledHiddenlabel": "Le paramètre On Wrap-Up State Over est-il activé ?",
  "OnavailablestatePlaceholder": "30s",
  "OnbusystatePlaceholder": "5m 0s",
  "OnnaordndstatePlaceholder": "3m 0s",
  "OnwrapupPlaceholder": "3m 0s",
  "ACDStateThresholds_SectionHeader": "Seuils d'état ACD",
  "ACDStateThresholds_SectionPara": "Vous pouvez activer des alarmes lorsque les agents restent trop longtemps dans un état DAA particulier. Choisissez les états ACD ",
  "NAME": "ACDStateThresholds"
}